



















































































import DynamicNotification from '@schachermayer/sch-vuejs-commons/src/components/pageLayout/DynamicNotification.vue';
import { StringFormatter } from '@schachermayer/sch-vuejs-commons/src/mixins';
import Velocity from 'velocity-animate';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import {
  BasketType,
  BudgetCheckResponse,
  PriceInformation,
  UserInfo,
} from '../../../build/swagger-code-extranet-api-definition';
import ApplicationBarStoreModule, { BasketItem as AddedBasketItem } from '../../store/modules/applicationBar.module';
import ExtranetConfigurationStoreModule from '../../store/modules/extranetConfiguration.module';
import BudgetExceededModal from './BudgetExceededModal.vue';

@Component({
  components: {
    BudgetExceededModal,
    DynamicNotification,
  },
})
export default class BasketItem extends Mixins(StringFormatter) {
  @Prop({ required: true }) public user: UserInfo;
  @Prop(String) public checkStandardBasketUrl: string;
        @Prop(String) public checkPuschBasketUrl: string;
        @Prop(String) public buyStandardBasketNowUrl: string;

        extranetConfigurationStore: ExtranetConfigurationStoreModule = getModule(ExtranetConfigurationStoreModule, this.$store);
        applicationBarStore: ApplicationBarStoreModule = getModule(ApplicationBarStoreModule, this.$store);

        showNotification = false;
        notificationMessage = '';
        showModal = false;
        BREAKPOINT_MD = 768;

        mounted() {
          window.addEventListener('resize', () => this.moveDropdownToRightOnMobile());
        }

        moveDropdownToRightOnMobile() {
          const viewPortWidth = window.innerWidth;

          const menu = document.querySelector(
              '.basket-item-dropdown-container',
          ) as HTMLElement;

          if (!menu || !menu.offsetParent || !menu.classList.contains('show')) {
            return;
          }

          const container = menu.offsetParent.getBoundingClientRect();
          let offsetLeft: number;
          if (viewPortWidth >= this.BREAKPOINT_MD) {
            offsetLeft = container.width - menu.getBoundingClientRect().width;
          } else {
            offsetLeft =
                viewPortWidth -
                container.left -
                menu.getBoundingClientRect().width;
          }

          menu.style.left = `${offsetLeft}px`;
        }

        get standardBasket() {
            if (!this.applicationBarStore.basketSummaryForAllBaskets.basketSummaries) {
                return null;
            }
            return this.applicationBarStore.basketSummaryForAllBaskets.basketSummaries.filter((basket) => basket.basketType === BasketType.Standard)[0];
        }

        get isOCIUser() {
            return this.user.isOciUser;
        }

        public isStandardBasket(type: BasketType) {
            return type === BasketType.Standard;
        }

        public isPuschBasket(type: BasketType) {
            return type === BasketType.PuSCH;
        }

        public formatPrice(priceInformation: PriceInformation, net: boolean) {
            if (this.extranetConfigurationStore.appBarConfiguration.showNetPrice) {
                const price: number = net ? priceInformation.priceNetto : priceInformation.priceGross;
                return this.formatMoneyValue(price, priceInformation.currency, '-');
            } else {
                return `- ${priceInformation.currency}`;
            }
        }

        get darkLayer(): HTMLElement {
            return this.$refs.basketDarkLayer as HTMLElement;
        }

        public onBasketShow() {
            this.darkLayer.setAttribute('show', '');
            setTimeout(() => this.moveDropdownToRightOnMobile(), 10);
            this.$emit('closeSideMenu');
        }

        public onBasketHide() {
            this.darkLayer.removeAttribute('show');
        }

        @Watch('addedBasketItems')
        performAddToBasketAnimation() {
            if (!this.applicationBarStore.addedBasketItems.empty()) {
                const addedBasketItem = this.applicationBarStore.addedBasketItems.pop();
                this.applicationBarStore.addToBasketSummary({price: addedBasketItem.price, net: true});
                this.performPackageAnimation(addedBasketItem);
            }
        }

        public checkBudget(event: Event) {
          event.preventDefault();
          this.showNotification = false;
          this.applicationBarStore.checkBudget().then((response: BudgetCheckResponse) => {
            if (response.success) {
              if (response.showDialog) {
                this.showModal = true;
              } else {
                this.oneClickBuy();
              }
            } else {
              this.showNotification = true;
              this.notificationMessage = response.message ? response.message : this.$tc('page.notifications.budgetCheck.failure.unknown');
            }
          });
        }

        public oneClickBuy() {
            (document.getElementById('oneClickBuyForm') as HTMLFormElement).submit();
        }

        public hideModal() {
            this.showModal = false;
        }

        private performPackageAnimation(addedBasketItem: AddedBasketItem) {
            const packageBoundingRect = (this.$refs.package as HTMLElement).getBoundingClientRect();
            const originalTop = packageBoundingRect.top;
            const originalLeft = packageBoundingRect.left + packageBoundingRect.width;
            Velocity.animate(this.$refs.animatedPackage, { top: addedBasketItem.fromTop, left: addedBasketItem.fromLeft, opacity: 1 }, 0);
            Velocity.animate(this.$refs.animatedPackage, { top: originalTop, left: originalLeft }, 800);
            Velocity.animate(this.$refs.animatedPackage, { opacity: 0 }, { duration: 0 });
        }
    }
